import Vue from 'vue'
import App from './views/App.vue'

import http from './plugins/axios'
import router from './plugins/vue-router'
import store from './plugins/vuex'
import i18n from './plugins/i18n'
import bus from './plugins/bus'

import moment from 'moment'

import vuetify from './plugins/ui/vuetify'

import VueScroll from 'vuescroll'

import GlobalMixin from './mixins/_global'

require('./plugins/ui/custom.sass')

window._ = require('lodash')
window.$moment = moment

$moment.locale('zh-cn')

Vue.use(http)
Vue.use(bus)
Vue.use(VueScroll, {
  ops: {
    scrollPanel: {
      scrollingX: false,
      easing: 'easeOutCubic'
    },
    bar: {
      onlyShowBarOnScroll: false,
      background: '#22DDAE'
    },
    vuescroll: {
      wheelScrollDuration: 600,
      wheelDirectionReverse: false
    }
  }
})

Vue.config.productionTip = false

Vue.mixin(GlobalMixin)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
